import { useFormContext, Controller } from 'react-hook-form'
import { Input } from '@cb/apricot-react'
import { isEmpty } from 'lodash'
import { FIELD_RECOVERY_EMAIL } from '../constants'
import { validateEmail, validateFieldState } from '../validations'

function BfsRecoveryEmail() {
  const { control } = useFormContext()

  return (
    <>
      <Controller
        control={control}
        name={FIELD_RECOVERY_EMAIL}
        rules={{
          validate: value => (!isEmpty(value) ? validateEmail(value) : undefined),
        }}
        render={({
          field: {
            onChange, onBlur, value, disabled, name,
          },
          fieldState: { invalid, isDirty, isTouched, error },
        }) => (
          <Input
            label={<strong>Recovery email</strong>}
            name={name}
            value={value}
            onChange={value => onChange(value)}
            onBlur={value => onBlur(value)}
            clearable={false}
            floating={false}
            autoComplete="off"
            maxLength="50"
            disabled={disabled}
            validation={validateFieldState({
              invalid,
              isDirty,
              isTouched,
              error,
              value,
            })}
            validationMsg={error?.message}
          />
        )}
      />
      <p>
        <strong>Important:</strong> Please provide a recovery email so we can help if you&#39;re unable to access
        BigFuture School with your phone. We won&#39;t use this email for any other reason, and we
        will only use the most recent recovery email you provide.
      </p>
    </>
  )
}

export default BfsRecoveryEmail
